import { AppThunkAction } from '../store';
import { ActionTypes as NotificationsStoreActionTypes, AddNotificationAction } from './NotificationsStore';
import { FetchConfig } from './middlewares/FetchMiddleware';
import { history } from '../AppHistory';
import { PowerOfAttorney, AvailablePowerOfAttorney } from '../api/client';
import { Reducer } from 'redux';
import { v4 } from 'uuid';

export enum ActionTypes {
  REGISTER_POWER_OF_ATTORNEY = '@@powerOfAttorney/SUBMIT_CONVERSATION',
  REGISTER_POWER_OF_ATTORNEY_REQUEST = '@@powerOfAttorney/REGISTER_POWER_OF_ATTORNEY_REQUEST',
  REGISTER_POWER_OF_ATTORNEY_SUCCESS = '@@powerOfAttorney/REGISTER_POWER_OF_ATTORNEY_SUCCESS',
  REGISTER_POWER_OF_ATTORNEY_FAILURE = '@@powerOfAttorney/REGISTER_POWER_OF_ATTORNEY_FAILURE',
  DEACTIVATE_POWER_OF_ATTORNEY = '@@powerOfAttorney/DEACTIVATE_POWER_OF_ATTORNEY',
  DEACTIVATE_POWER_OF_ATTORNEY_REQUEST = '@@powerOfAttorney/DEACTIVATE_POWER_OF_ATTORNEY_REQUEST',
  DEACTIVATE_POWER_OF_ATTORNEY_SUCCESS = '@@powerOfAttorney/DEACTIVATE_POWER_OF_ATTORNEY_SUCCESS',
  DEACTIVATE_POWER_OF_ATTORNEY_FAILURE = '@@powerOfAttorney/DEACTIVATE_POWER_OF_ATTORNEY_FAILURE',
  REGISTER_SELECTED_POWER_OF_ATTORNEY = '@@powerOfAttorney/REGISTER_SELECTED_POWER_OF_ATTORNEY',
  CLEAR_SELECTED_POWER_OF_ATTORNEY = '@@powerOfAttorney/CLEAR_SELECTED_POWER_OF_ATTORNEY',
  GET_SELECTED_POWER_OF_ATTORNEY = '@@powerOfAttorney/GET_SELECTED_POWER_OF_ATTORNEY',
  CLEAR_POWER_OF_ATTORNEYS = '@@powerOfAttorney/CLEAR_POWER_OF_ATTORNEYS',
  GET_POWER_OF_ATTORNEYS_BY_DEBTOR_IDS = '@@powerOfAttorney/GET_POWER_OF_ATTORNEYS_BY_DEBTOR_IDS',
  GET_POWER_OF_ATTORNEYS_BY_DEBTOR_IDS_REQUEST = '@@powerOfAttorney/GET_POWER_OF_ATTORNEYS_BY_DEBTOR_IDS_REQUEST',
  GET_POWER_OF_ATTORNEYS_BY_DEBTOR_IDS_SUCCESS = '@@powerOfAttorney/GET_POWER_OF_ATTORNEYS_BY_DEBTOR_IDS_SUCCESS',
  GET_POWER_OF_ATTORNEYS_BY_DEBTOR_IDS_FAILURE = '@@powerOfAttorney/GET_POWER_OF_ATTORNEYS_BY_DEBTOR_IDS_FAILURE',
}

export interface PowerOfAttorneyState {
  selectedPowerOfAttorney: AvailablePowerOfAttorney | null;
  isLoading: boolean;
  powerOfAttorneyByIds: { [key: string]: AvailablePowerOfAttorney[] };
}

interface RegisterPowerOfAttorneyAction { type: ActionTypes.REGISTER_POWER_OF_ATTORNEY; fetchConfig: FetchConfig; }
interface RegisterPowerOfAttorneyRequestAction { type: ActionTypes.REGISTER_POWER_OF_ATTORNEY_REQUEST; }
interface RegisterPowerOfAttorneySuccessAction { type: ActionTypes.REGISTER_POWER_OF_ATTORNEY_SUCCESS; }
interface RegisterPowerOfAttorneyFailureAction { type: ActionTypes.REGISTER_POWER_OF_ATTORNEY_FAILURE; }
interface DeactivatePowerOfAttorneyAction { type: ActionTypes.DEACTIVATE_POWER_OF_ATTORNEY; fetchConfig: FetchConfig; }
interface DeactivatePowerOfAttorneyRequestAction { type: ActionTypes.DEACTIVATE_POWER_OF_ATTORNEY_REQUEST; debtorId: string; id: string; }
interface DeactivatePowerOfAttorneySuccessAction { type: ActionTypes.DEACTIVATE_POWER_OF_ATTORNEY_SUCCESS; debtorId: string; id: string; deactivatedBy: string; }
interface DeactivatePowerOfAttorneyFailureAction { type: ActionTypes.DEACTIVATE_POWER_OF_ATTORNEY_FAILURE; debtorId: string; id: string; }
interface RegisterSelectedPowerOfAttorneyAction { type: ActionTypes.REGISTER_SELECTED_POWER_OF_ATTORNEY; powerOfAttorney: AvailablePowerOfAttorney; }
interface ClearSelectedPowerOfAttorneyAction { type: ActionTypes.CLEAR_SELECTED_POWER_OF_ATTORNEY; }
interface GetSelectedPowerOfAttorneyAction { type: ActionTypes.GET_SELECTED_POWER_OF_ATTORNEY; powerOfAttorney: AvailablePowerOfAttorney; }
interface ResetPowerOfAttorneysAction { type: ActionTypes.CLEAR_POWER_OF_ATTORNEYS; }
interface GetPowerOfAttorneysByDebtorIdsAsMapAction { type: ActionTypes.GET_POWER_OF_ATTORNEYS_BY_DEBTOR_IDS; fetchConfig: FetchConfig; }
interface GetPowerOfAttorneysByDebtorIdsAsMapRequestAction { type: ActionTypes.GET_POWER_OF_ATTORNEYS_BY_DEBTOR_IDS_REQUEST; debtorIds: string[]; }
interface GetPowerOfAttorneysByDebtorIdsAsMapSuccessAction { type: ActionTypes.GET_POWER_OF_ATTORNEYS_BY_DEBTOR_IDS_SUCCESS; debtorIds: string[]; response: { [key: string]: AvailablePowerOfAttorney[] }; }
interface GetPowerOfAttorneysByDebtorIdsAsMapFailureAction { type: ActionTypes.GET_POWER_OF_ATTORNEYS_BY_DEBTOR_IDS_FAILURE; debtorIds: string[]; }

export type KnownAction = AddNotificationAction
  | RegisterPowerOfAttorneyAction
  | RegisterPowerOfAttorneyRequestAction
  | RegisterPowerOfAttorneySuccessAction
  | RegisterPowerOfAttorneyFailureAction
  | DeactivatePowerOfAttorneyAction
  | DeactivatePowerOfAttorneyRequestAction
  | DeactivatePowerOfAttorneySuccessAction
  | DeactivatePowerOfAttorneyFailureAction
  | RegisterSelectedPowerOfAttorneyAction
  | ClearSelectedPowerOfAttorneyAction
  | GetSelectedPowerOfAttorneyAction
  | ResetPowerOfAttorneysAction
  | GetPowerOfAttorneysByDebtorIdsAsMapAction
  | GetPowerOfAttorneysByDebtorIdsAsMapRequestAction
  | GetPowerOfAttorneysByDebtorIdsAsMapSuccessAction
  | GetPowerOfAttorneysByDebtorIdsAsMapFailureAction;

export const actionCreators = {
  getPowerOfAttorneysByDebtorIds: (debtorIds: string[]): AppThunkAction<KnownAction> => dispatch => {
    return dispatch({
        type: ActionTypes.GET_POWER_OF_ATTORNEYS_BY_DEBTOR_IDS,
        fetchConfig: {
          init: { type: ActionTypes.GET_POWER_OF_ATTORNEYS_BY_DEBTOR_IDS_REQUEST },
          method: 'POST',
          body: debtorIds,
          path: `/api/powerofattorneys/debtorids`,
          signal: undefined,
          success: (json) => {
            dispatch({ 
                type: ActionTypes.GET_POWER_OF_ATTORNEYS_BY_DEBTOR_IDS_SUCCESS, 
                debtorIds: debtorIds, 
                response: json
            });
          },
          failure: (error: string) => {
            dispatch({ type: ActionTypes.GET_POWER_OF_ATTORNEYS_BY_DEBTOR_IDS_FAILURE, debtorIds });
            dispatch({
                type: NotificationsStoreActionTypes.ADD_NOTIFICATION,
                notification: { 
                    message: `Kunne ikke hente fullmakter for følgende debitorer: ${debtorIds.join(", ")}, ${error}`, 
                    variant: 'error' 
                }
            });
          }
        }
    });
  },
  registerPowerOfAttorney: (
    debtorId: string,
    onBehalfOf: string,
    grantTo: string,
    duration: string,
    includeAccess: boolean,
    includeAgreement: boolean
  ): AppThunkAction<KnownAction> => (dispatch, getState) => {

    const powerOfAttorney: PowerOfAttorney = {
      id: v4(),
      debtorId: debtorId,
      onBehalfOf: onBehalfOf,
      grantTo: grantTo,
      duration: duration,
      includeAccess: includeAccess,
      includeAgreement: includeAgreement
    };
    const selectedPowerOfAttorneyFromNew: AvailablePowerOfAttorney = {
      id: powerOfAttorney.id,
      debtorId: powerOfAttorney.debtorId,
      onBehalfOf: powerOfAttorney.onBehalfOf,
      grantTo: powerOfAttorney.grantTo,
      includeAccess: powerOfAttorney.includeAccess,
      includeAgreement: powerOfAttorney.includeAgreement,
      duration: powerOfAttorney.duration,
      registeredAtUtc: new Date(),
      registeredBy: undefined,
      active: true,
      deactivatedBy: undefined,
      deactivatedAtUtc: undefined
    };

    return dispatch({
      type: ActionTypes.REGISTER_POWER_OF_ATTORNEY,
      fetchConfig: {
        init: { type: ActionTypes.REGISTER_POWER_OF_ATTORNEY_REQUEST },
        path: `/api/powerofattorneys`,
        method: 'POST',
        body: powerOfAttorney,
        signal: undefined,
        success: (json) => {
          dispatch({ type: ActionTypes.REGISTER_POWER_OF_ATTORNEY_SUCCESS });
          dispatch({ type: ActionTypes.REGISTER_SELECTED_POWER_OF_ATTORNEY, powerOfAttorney: selectedPowerOfAttorneyFromNew });
          history.push(`/debtorlookup`);
        },
        failure: (error: string) => {
          dispatch({ type: ActionTypes.REGISTER_POWER_OF_ATTORNEY_FAILURE });
          dispatch({ type: NotificationsStoreActionTypes.ADD_NOTIFICATION, notification: { message: 'Kunne ikke registrere fullmakten', variant: 'error' } });
        }
      }
    });
  },
  deactivatePowerOfAttorney: (debtorId: string, id: string, deactivatedBy: string): AppThunkAction<KnownAction> => (dispatch, getState) => {
    return dispatch({
      type: ActionTypes.DEACTIVATE_POWER_OF_ATTORNEY,
      fetchConfig: {
        init: { type: ActionTypes.DEACTIVATE_POWER_OF_ATTORNEY_REQUEST },
        path: `/api/powerofattorneys`,
        method: 'PUT',
        body: { debtorId: debtorId, powerOfAttorneyId: id },
        signal: undefined,
        success: (json) => {
          dispatch({ type: ActionTypes.DEACTIVATE_POWER_OF_ATTORNEY_SUCCESS, debtorId: debtorId, id: id, deactivatedBy: deactivatedBy });
        },
        failure: (error: string) => {
          dispatch({ type: ActionTypes.DEACTIVATE_POWER_OF_ATTORNEY_FAILURE, debtorId: debtorId, id: id });
          dispatch({ type: NotificationsStoreActionTypes.ADD_NOTIFICATION, notification: { message: 'Kunne ikke deaktivere fullmakten', variant: 'error' } });
        }
      }
    });
  },
  registerSelectedPowerOfAttorney: (powerOfAttorney: AvailablePowerOfAttorney): AppThunkAction<KnownAction> => (dispatch, getState) => {
    return dispatch({ type: ActionTypes.REGISTER_SELECTED_POWER_OF_ATTORNEY, powerOfAttorney: powerOfAttorney });
  },
  clearSelectedPowerOfAttorney: (): AppThunkAction<KnownAction> => (dispatch, getState) => {
    return dispatch({ type: ActionTypes.CLEAR_SELECTED_POWER_OF_ATTORNEY });
  },
  clearPowerOfAttorneys: (): AppThunkAction<KnownAction> => (dispatch, getState) => {
    return dispatch({ type: ActionTypes.CLEAR_POWER_OF_ATTORNEYS });
  },
};

const initialPowerOfAttorneysByIds: { [key: string]: AvailablePowerOfAttorney[] } = {}

export const initialState: PowerOfAttorneyState = { selectedPowerOfAttorney: null, isLoading: false, powerOfAttorneyByIds: initialPowerOfAttorneysByIds };

export const reducer: Reducer<PowerOfAttorneyState | undefined, KnownAction> = (state: PowerOfAttorneyState = initialState, action: KnownAction) => {
  switch (action.type) {
    case ActionTypes.GET_POWER_OF_ATTORNEYS_BY_DEBTOR_IDS_REQUEST:
      return { ...state, isLoading: true };
    case ActionTypes.GET_POWER_OF_ATTORNEYS_BY_DEBTOR_IDS_SUCCESS:
      return { ...state, powerOfAttorneyByIds: action.response, isLoading: false };
    case ActionTypes.REGISTER_SELECTED_POWER_OF_ATTORNEY:
      return { ...state, selectedPowerOfAttorney: action.powerOfAttorney };
    case ActionTypes.CLEAR_SELECTED_POWER_OF_ATTORNEY:
      return { ...state, selectedPowerOfAttorney: null };
    case ActionTypes.DEACTIVATE_POWER_OF_ATTORNEY_SUCCESS:
      return {
        ...state,
        powerOfAttorneyByIds: {
          ...state.powerOfAttorneyByIds,
          [action.debtorId]: state.powerOfAttorneyByIds[action.debtorId].map(
            (powerOfAttorney) => {
              if (powerOfAttorney.id === action.id) {
                return {
                  ...powerOfAttorney,
                  active: false,
                  deactivatedBy: action.deactivatedBy,
                  deactivatedAtUtc: new Date(),
                };
              }
              return powerOfAttorney;
            }
          ),
        },
      };
    case ActionTypes.GET_POWER_OF_ATTORNEYS_BY_DEBTOR_IDS_FAILURE:
      return initialState;
    case ActionTypes.CLEAR_POWER_OF_ATTORNEYS:
      return initialState;
    default:
      return state;
  }
};